import {
  validEnterpriseAndGetInfo,
} from '@/api/domain/organize'

// 当前页面状态
export const FORM_MODE = {
  ADD: 'add', // 新增
  EDIT: 'edit', // 编辑
}

export const businessStatusOptions = [
  {
    name: '存续（开业/在营/在册）',
    code: 10,
  },
  {
    name: '在业',
    code: 20,
  },
  {
    name: '吊销',
    code: 30,
  },
  {
    name: '注销',
    code: 40,
  },
  {
    name: '迁入',
    code: 50,
  },
  {
    name: '迁出',
    code: 60,
  },
  {
    name: '停业',
    code: 70,
  },
  {
    name: '清算',
    code: 80,
  },
]

export const defaultModel = {
  id: '',
  corporationName: '',
  licenceNo: '',
  legalName: '',
  legalIdNo: '',
  legalMobile: '',
  businessLicensePic: [],
  contactName: '',
  contactMobile: '',
  registrationMobile: '',
  registrationAddress: '',
  entityType: 2, // 新增传默认值非代扣子户
}


// 创建验证器工厂函数
export const createLicenceNoValidator = (model, formMode) => {
  return async (_, value, callback) => {
    if (!value) {
      callback(new Error('请输入社会统一信用代码'))
    } else if (value.length < 18) {
      callback(new Error('请输入18位统一社会信用代码'))
    } else {
      try {
        const { code, data } = await validEnterpriseAndGetInfo({
          corporationName: model.value.corporationName,
          licenceNo: value,
        })

        if (code === 1 && formMode.value === FORM_MODE.ADD) {
          if (data.exist) {
            callback(new Error('该主体已存在'))
          } else if (data.enterprise) {
            model.value = Object.keys(model.value).reduce(
              (acc, key) => {
                if (!acc[key] || acc[key] === '') {
                  acc[key] = data.enterprise[key]
                }
                return acc
              },
              { ...model.value },
            )
          }
        }
        callback()
      } catch (error) {
        callback(new Error('验证失败'))
      }
    }
  }
}

// 创建规则工厂函数
export const createRules = (model, formMode) => ({
  corporationName: [
    { required: true, message: '请输入主体全称', trigger: 'blur' },
  ],
  licenceNo: [
    {
      required: true,
      trigger: 'blur',
      validator: createLicenceNoValidator(model, formMode),
    },
  ],
  businessLicensePic: [
    { required: true, message: '请上传营业执照', trigger: 'change' },
  ],
  legalName: [
    { required: true, message: '请输入法人姓名', trigger: 'blur' },
  ],
  legalIdNo: [
    {
      required: true,
      trigger: 'blur',
      message: '请输入正确的法人身份证号',
    },
  ],
  legalMobile: [
    {
      required: true,
      trigger: 'blur',
      message: '请输入正确的法人手机号',
    },
  ],
  contactName: [
    { required: true, message: '请输入联系人姓名', trigger: 'blur' },
  ],
  contactMobile: [
    {
      required: true,
      trigger: 'blur',
      message: '请输入正确的联系人手机号',
    },
  ],
  contactAddress: [
    {
      required: true,
      message: '请输入联系地址',
      trigger: 'blur',
    },
  ],
})

